import { IConfirmationModalProps, INotificationModalProps } from '../types';
import { IApiError } from '../../../services';
import { NotificationModal } from '../notification';
import { AxiosPromise } from 'axios';
import React from 'react';

export class ConfirmationModalPropsFactory {
  static CreateDeleteEntityConfirmationModal(
    entityName: string,
    id: number,
    promise: (id: number) => AxiosPromise,
    onShowModal: (component: React.ComponentType<any>, props: any) => void,
    onHideModal: () => void,
    onError: (errors: Array<string>) => void,
    onSuccess: () => void,
  ): IConfirmationModalProps {
    return {
      title: `Delete ${entityName}`,
      message: `Are you sure that you to permanently delete this ${entityName.toLowerCase()}?`,
      icon: ['far', 'question-circle'],
      kind: 'danger',
      onConfirmed: () => {
        onHideModal();

        promise(id)
          .then(() => onSuccess())
          .catch((error: IApiError) => {
            if (error && error.errorNumber === 1006) {
              const props: INotificationModalProps = {
                title: `Unable to delete ${entityName}`,
                message: `This ${entityName.toLowerCase()} cannot be deleted because it is being used by one or more sites.`,
                icon: ['far', 'info-circle'],
                kind: 'info',
                onRequestClose: () => {
                  onHideModal();
                },
              };

              onShowModal(NotificationModal, props);
            } else {
              onError(error.messages);
            }
          });
      },
      onRequestClose: () => onHideModal(),
    };
  }
}
